/** Заглушка для опциональных peer deps (напр. react-native-reanimated у gesture-handler). */
module.exports = {};
